import { useCallback } from 'react';

export default ({
  handleIssueSyncClick,
  handleIssuePrintClick,
  handleIssueEmailClick,
  confirmationDialogName,
  onClose,
  setFailedLineItems
}) => {
  const handleClose = useCallback(() => {
    onClose();
    setFailedLineItems([]);
  }, [onClose, setFailedLineItems]);
  const handleClick = useCallback(async () => {
    await {
      sync: handleIssueSyncClick,
      print: handleIssuePrintClick,
      email: handleIssueEmailClick
    }[confirmationDialogName]();
    onClose();
  }, [
    handleIssueSyncClick,
    handleIssuePrintClick,
    handleIssueEmailClick,
    confirmationDialogName,
    onClose
  ]);

  return {
    handleClose,
    handleClick
  };
};
